<template>
  <v-data-table
    show-select
    v-model="localValue"
    :headers="headers"
    :items="fornecedores.content"
    class="elevation-1 mt-2"
    :loading="loading"
    :server-items-length="fornecedores.total"
    @update:options="updateOptions"
    @item-selected="onSelectItem"
    :footer-props="footerOptions"
    no-data-text="Nenhum fornecedor encontrado"
    loading-text="Carregando fornecedores..."
    :options="optionsList"
  >
    <template v-slot:item.pessoa.nome="{ item }">
      <px-span-tooltip
        top
        :text="codigoInterno(item)"
        tooltip="Código interno do fornecedor"/>
        {{ item.pessoa.nome }}
      <px-open-pagina-fornecedor :id="item.id"/>
    </template>
    <template v-slot:item.cnpj="{ item }">
      {{ item.pessoa.cnpj | cnpj }}
    </template>
    <template v-slot:item.local="{ item }">
      {{ item.endereco.municipio.nome }} ({{ item.endereco.estado.sigla }})
    </template>
  </v-data-table>
</template>

<script>
export default {
  props: {
    value: Array,
    fornecedores: Object,
    loading: Boolean,
    optionsList: Object,
    onChangeOptions: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      maxSelect: 20,
      footerOptions: {
        itemsPerPageOptions: [5, 10, 15],
        itemsPerPageText: 'Linhas por página',
      },
      headers: [
        {
          text: 'Nome',
          value: 'pessoa.nome',
          sortable: true,
        },
        {
          text: 'CNPJ',
          value: 'cnpj',
          sortable: true,
        },
        {
          text: 'Local',
          value: 'local',
          sortable: false,
        },
      ],
    };
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
    codigoInterno() {
      return item => (item.codigoInterno ? `${item.codigoInterno} -` : '');
    },
  },
  methods: {
    onSelectItem() {
    },
    updateOptions(options) {
      this.onChangeOptions(options);
    },
  },
  watch: {
    localValue(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      if (this.localValue.length > this.maxSelect) {
        this.localValue = [...oldValue];
      }
    },
  },
};
</script>
